<template>
  <div>
    <a-modal
      :title="courseDetail.courseName"
      :maskClosable="false"
      :width="1000"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :cancelText="'取消'"
      :okText="'确定'"
      @cancel="handleCancel"
      :footer="null"
    >
      <div class="institution-info">
        <div><span class="name">当前课节信息</span></div>
        <div>
          <span class="key">课节名称：</span>
          <span class="value">{{ courseDetail.lessonName }}</span>
        </div>
        <div>
          <span class="key">课节码：</span>
          <span class="value">{{ courseDetail.courseCode }}</span>
        </div>
        <div>
          <span class="key">上课计划：</span>
          <span class="value class-time">
            <div v-for="(item, index) in courseDetail.teachingPlanList" :key="index">
              <span>{{ item.classWeeks | weekName }}&nbsp;&nbsp;</span>
              <span>{{ item.classTime }}</span>
            </div>
          </span>
        </div>
        <div>
          <span class="key">上课日期：</span>
          <span class="value">{{ courseDetail.attendDate }}</span>
        </div>
        <div>
          <span class="key">上课地点：</span>
          <span class="value">{{ courseDetail.placeName }}</span>
        </div>
        <div>
          <span class="key">上课老师：</span>
          <span class="value">{{ courseDetail.teacherName }}</span>
        </div>
        <div>
          <span class="key">上课提供方：</span>
          <span class="value">{{ courseDetail.providerName }}</span>
        </div>

        <!-- 老师出勤 -->
        <div><span class="name gap">老师出勤</span></div>
        <div class="lesson-table">
          <div class="header">
            <span class="cell cell_4">老师姓名</span>
            <span class="cell cell_4">老师手机号</span>
            <span class="cell cell_4">出勤状态</span>
            <span class="cell cell_4">出勤时间</span>
          </div>
          <div class="row" v-if="courseDetail.teacherCheckinDTO">
            <span class="cell cell_4">{{ courseDetail.teacherCheckinDTO.teacherName }}</span>
            <span class="cell cell_4">{{ courseDetail.teacherCheckinDTO.mobile }}</span>
            <span class="cell cell_4">{{ courseDetail.teacherCheckinDTO.checkinStatusText }}</span>
            <span class="cell cell_4">{{ courseDetail.teacherCheckinDTO.gmtCreate }}</span>
          </div>
        </div>

        <!-- 学生点名 -->
        <div><span class="name gap">学生点名</span></div>
        <div class="lesson-table">
          <div class="header">
            <span class="cell">学生姓名</span>
            <span class="cell">原生班级</span>
            <span class="cell">班主任</span>
            <span class="cell">班主任电话</span>
            <span class="cell">点名状态</span>
            <span class="cell">操作</span>
          </div>
          <div class="row" v-for="(item, index) in courseDetail.studentCheckinList" :key="index">
            <span class="cell">{{ item.studentName }}</span>
            <span class="cell">{{ item.originalClassName }}</span>
            <span class="cell">{{ item.headteacherName }}</span>
            <span class="cell">{{ item.headteacherMobile }}</span>
            <span class="cell">{{ item.statusText }}</span>
            <span class="cell">
              <template>
                <span class="oper hover-font-active" @click="updateStudent(item)">修改</span>
              </template>
            </span>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      title="学生点名"
      :maskClosable="false"
      :width="500"
      :visible="visible_inner"
      :cancelText="'取消'"
      :okText="'确定'"
      @cancel="handleCancel_inner"
      @ok="handleSubmit"
    >
      <a-form class="class-form" layout="horizontal" :form="form">
        <a-form-item
          class="update-time-form"
          label="状态"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-select
            placeholder="请选择"
            v-decorator="['status', { rules: [{ required: true, message: '请选择' }] }]"
          >
            <a-select-option value="1">已出勤</a-select-option>
            <a-select-option value="2">请假</a-select-option>
            <a-select-option value="3">缺勤</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import education from '../../api/education'

import student from '../../api/student'

export default {
  name: 'courseDetailModal',
  data() {
    return {
      visible: false,
      visible_inner: false,
      form: this.$form.createForm(this),
      confirmLoading: false,
      courseDetail: {},
      updateObj: {}, //修改的对象
    }
  },
  methods: {
    //修改上课时间
    updateStudent(value) {
      this.visible_inner = true
      this.updateObj = value

      if (value.status) {
        let formData = {}
        formData.status = value.status.toString()
        setTimeout(() => {
          this.form.setFieldsValue(formData)
        }, 100)
      } else {
        this.form.resetFields()
      }
    },

    //修改上课时间-确认
    handleSubmit() {
      this.form.validateFields((err, value) => {
        //校验通过
        if (!err) {
          student.updateCheckin(this.updateObj.id, value).then(res => {
            this.$message.success('修改成功')
            this.handleCancel_inner()
            this.getAfterSchool()
          })
        }
      })
    },

    //初始化，显示
    init(detail = {}) {
      console.log(detail)
      this.courseId = detail.id || detail.scheduleId
      console.table(this.courseId, detail, detail.id, detail.scheduleId)
      this.visible = true
      this.getAfterSchool()
    },

    //查询放假信息：信息 + 课表列表
    getAfterSchool() {
      education.getAfterSchool(this.courseId).then(res => {
        this.courseDetail = res.data
      })
    },

    //隐藏
    handleCancel() {
      this.visible = false
    },

    //取消上课时间弹窗
    handleCancel_inner() {
      this.visible_inner = false
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.institution-info {
  text-align: left;
  height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  div {
    font-size: 16px;
    line-height: 32px;
    .gap {
      margin-top: 20px;
      display: block;
    }
    .name {
      font-size: 16px;
      font-weight: 500;
      color: $normal-color;
    }
    .key {
      display: inline-block;
      font-weight: 600px;
      color: $normal-color-light;
      width: 130px;
      text-align: right;
    }
    .value {
      color: $normal-color-dark;
      padding-left: 6px;
      display: inline-block;
      padding-right: 16px;
      text-align: left;
      img {
        width: 100px;
        height: 100px;
        vertical-align: top;
        position: relative;
        top: 10px;
      }
    }
    .oper {
      color: $primary-color-dark;
      cursor: pointer;
    }
    .intro {
      width: 100%;
      padding: 0px 20px;
      display: inline-block;
      color: $normal-color-dark;
    }
  }
}

//课节目录
.lesson-table {
  margin: 10px 20px;
  border-left: 1px solid $border-color;
  border-bottom: 1px solid $border-color;
  .cell {
    border-right: 1px solid $border-color;
    border-top: 1px solid $border-color;
    display: inline-block;
    width: calc((100%) / 6);
    height: 34px;
    line-height: 34px;
    text-align: center;
    vertical-align: top;
    font-size: 14px;
  }
  .cell_4 {
    width: calc((100%) / 4);
  }
  .time {
    width: 150px !important;
  }
  > .header {
    .cell {
      font-weight: 500;
      color: $normal-color;
      font-size: 16px !important;
    }
  }
  .row {
    .oper {
      color: $primary-color;
      display: inline-block;
      padding: 0px 4px;
    }
  }
}

.update-time-form {
  margin-bottom: 10px !important;
}
.class-time {
  vertical-align: top;
}
</style>
